import * as Sentry from "@sentry/nextjs";

const isProduction = process.env.NODE_ENV === "production";

Sentry.init({
  dsn:
    process.env.NEXT_PUBLIC_SENTRY_DSN ||
    "https://c3a361e152ac2637792373a5f8f6d426@o4512122560708608.ingest.us.sentry.io/4512122800504832",

  environment: process.env.NODE_ENV || "production",
  enabled: process.env.NEXT_PUBLIC_SENTRY_ENABLED !== "false",

  integrations: [
    Sentry.replayIntegration({
      maskAllText: true,
      blockAllMedia: true,
    }),
  ],

  // Sample 20% of transactions in production
  tracesSampleRate: process.env.NEXT_PUBLIC_SENTRY_TRACES_SAMPLE_RATE
    ? parseFloat(process.env.NEXT_PUBLIC_SENTRY_TRACES_SAMPLE_RATE)
    : isProduction ? 0.2 : 1.0,

  // Replay session sample rate (low in production to preserve quota)
  replaysSessionSampleRate: isProduction ? 0.05 : 0.1,

  // 100% replay capture when an error occurs for easier troubleshooting
  replaysOnErrorSampleRate: 1.0,
});

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;

